var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('delete-button',_vm._b({on:{"click":_vm.deleteHandler}},'delete-button',Object.assign({}, _vm.$attrs, {icon: _vm.icon, loading: _vm.loading, suppressConfirmation: _vm.suppressConfirmation}),false))}
var staticRenderFns = []

export { render, staticRenderFns }